import { stylesCSS } from "./styles-css";
export function initialHTML() {
    document.querySelector(".song-status").innerHTML = `
        <style>
        ${stylesCSS()}
        </style>
        <div>
            <p class="back"><a href="/members/song-tracker"><i class="fas fa-arrow-left">&nbsp;</i>Song tracker tool</a></p>
            <p>Use the search below to see if your song choice is known by this congregation or not.</p><input
                disabled="disabled" placeholder="Do we know the song?" id="search-known" />
        </div>
        <div class="song-container">
            <p class="loading"><i class="fas fa-spinner fa-spin">&nbsp;</i><span class="loading-msg">Loading list of songs from
                    the song tracker.</span></p>
        </div>
    `;
}
